import React from 'react';
import PropTypes from 'prop-types';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import Component from '@plone/volto/components/theme/Component/Component';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import { Icon } from 'semantic-ui-react'; // Import per l'icona


const LinkToImageTemplate = ({ 
  items, 
  linkTitle, 
  linkHref, 
  isEditMode, 
  showFourColums = false,
  linkText, 
  linkUrl, 
  alignButtonRight,   
  cardBackground = 'no-background', 
  data = {} 
}) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  const backgroundClass = data?.cardBackground || 'no-background';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }

  // Calcola la larghezza minima in base al numero di colonne
  const minWidth = showFourColums ? '220px' : '280px';

  return (
    <div className={`full-width-background-wrapper ${cardBackground}`}>
      <div className={`image-card-listing-container`}>
        <div className="image-card-listing" style={{
            gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}, 1fr))`
          }}>
          {items.map((item) => (
            <div className="image-card" key={item['@id']}>
              <ConditionalLink item={item} condition={!isEditMode}>
                {item.image_field && (
                  <div className="card-image-wrapper">

                    <Component
                      componentName="PreviewImage"
                      item={item}
                      alt={item.title || ''}
                      size="preview"
                    />
                  </div>
                )}
              </ConditionalLink>
            </div>
          ))}

          

          {link && <div className="footer">
            {link}
            
            </div>}
        </div>

        {linkUrl && (
            <div className={`link-button my-4 ${alignButtonRight ? 'align-right' : ''}`}>
              <a
                href={linkUrl}
                className={`btn btn-primary`}
              >
                {linkText || 'Scopri di più'}
              </a>
            </div>
          )}
        
      </div>
    </div>
  );
};

LinkToImageTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkTitle: PropTypes.any,
  linkHref: PropTypes.any,
  isEditMode: PropTypes.bool,
  data: PropTypes.object,
};

export default LinkToImageTemplate;